
 export const getMediaUrl = () => {
  const baseUrl = process.env.REACT_APP_MEDIA_URL
  // проверяем на то, что путь в .env абсолютный или нет
  if(baseUrl[0] === 'h'){
    return baseUrl
  }
  const loc = window.location;

  return `${loc.protocol}//${loc.host}${baseUrl}`
}

// Некоторые эндпоинты (например курьер: avatar/passport_photo/...) отдают уже
// готовый путь с префиксом (например "/media/attachments/x.jpg"), а не голое
// имя файла как остальные аттачменты. Использовать с ним getMediaUrl() напрямую
// нельзя - получится задвоенный "/media/media/...". Эта функция определяет,
// что перед ней - и в обоих случаях возвращает рабочий абсолютный URL.
export const resolveAttachmentUrl = (url) => {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url

  const mediaUrl = getMediaUrl()
  const mediaOrigin = mediaUrl.replace(/\/media\/?$/, '')

  return `${mediaOrigin}${url.startsWith('/') ? '' : '/'}${url}`
}